import { render, staticRenderFns } from "./ProfilePostsPage.vue?vue&type=template&id=ea4ed748&"
import script from "./ProfilePostsPage.vue?vue&type=script&lang=js&"
export * from "./ProfilePostsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports